/**
 * Utilitaires UI.
 */
import { formatFcfa } from '@boutikos/domain';

export const argent = (n: number): string => formatFcfa(n);

export const dateCourte = (ts: number): string => {
  const d = new Date(ts);
  return d.toLocaleDateString('fr-BJ', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

export const heureCourte = (ts: number): string => {
  const d = new Date(ts);
  return d.toLocaleTimeString('fr-BJ', { hour: '2-digit', minute: '2-digit' });
};

export const joursAvant = (ts: number, maintenant = Date.now()): number => {
  return Math.floor((ts - maintenant) / 86_400_000);
};
